// Canonical Russian translations. The exported `ru` object's shape becomes
// the `Translations` type that `en` and `pl` must conform to — TypeScript
// catches missing keys on the other languages.
export const ru = {
  header: {
    nav: {
      howItWorks: 'Как это работает',
      example:    'Пример отчёта',
      faq:        'FAQ',
    },
    cta: 'Узнать свой план',
  },

  footer: {
    tagline: 'Разбираем состав ваших баночек и составляем план ухода под вашу кожу — без лишних активов и трат.',
    nav:     'Навигация',
    contact: 'Контакты',
    privacy: 'Конфиденциальность',
    copyright: '© {year} SkinBloom · Персональный анализ ухода',
    disclaimer: 'Не заменяет консультацию дерматолога',
    links: {
      howItWorks: 'Как это работает',
      example:    'Пример отчёта',
      whyBetter:  'Преимущества',
      faq:        'FAQ',
    },
  },

  hero: {
    badge: 'Персональный уход · $4.99 · 100% возврат',
    headline: ['План ухода', 'для вашей кожи —', 'с учётом ваших средств.'],
    subhead:  'Покажите свои баночки — разберёмся, что оставить, что заменить и чего не хватает. План придёт на e-mail за 5 минут.',
    ctaPrimary:   'Узнать свой план',
    ctaSecondary: 'Пример отчёта',
    trustCount:   '12 000+ планов создано',
    badges: {
      private: 'Конфиденциально',
      email:   'На e-mail',
      time:    '5 минут',
    },
    cards: {
      skinType: {
        label: 'ТИП КОЖИ',
        value: 'Комбинированная,\nчувствительная',
      },
      actives: {
        label: 'АКТИВЫ',
        items: ['Ниацинамид', 'Церамиды', 'Гиалуроновая к-та'],
      },
      plan: {
        label: 'ПЛАН УХОДА',
        text:  'Утро · Вечер · 5 шагов',
      },
      report: {
        title:  'Отчёт готовится',
        status: 'Почти готово!',
      },
    },
  },

  problem: {
    titleA: 'Косметики много.',
    titleB: 'Понимания — мало.',
    cards: [
      { title: 'Покупаете по отзывам',           text: 'А подойдёт ли это именно вашей коже — никто не сказал.' },
      { title: 'Состав — как иностранный язык',  text: 'Кислоты, ретинол, церамиды, ниацинамид. Что с чем сочетать — непонятно.' },
      { title: 'Полка растёт, а порядка — нет',  text: 'Утром у зеркала всё ещё неясно, чем мазать первым и зачем.' },
    ],
  },

  preview: {
    eyebrow:  'Пример отчёта',
    titleA:   'Вот что вы получите',
    titleB:   'после анализа',
    subtitle: 'Не общие советы, а конкретный план: что оставить, что убрать, что докупить и как использовать.',
    moreNote: 'В вашем отчёте — это и ещё 5 разделов: подробный план ухода, разбор по этапам, прогноз результатов и рекомендации.',
    ctaPrimary: 'Хочу такой же план',
    ctaOverlay: 'Посмотреть полный пример отчёта',

    swaps: {
      title: 'Анализ ваших средств',
      rows: [
        { from: 'TO Niacinamide 10% + Zinc',  to: 'G&G Stress Less',         note: '10% слишком сильно для чувствительной' },
        { from: 'CeraVe Hydrating Cleanser',  to: 'CeraVe Hydrating Cleanser', note: 'Подходит — оставляем' },
        { from: null,                          to: 'Balea Panthenol Serum',   note: 'Нужен для восстановления барьера' },
      ],
      missing: 'В вашем уходе нет',
    },

    ingredients: {
      title: 'Ингредиенты под вашу кожу',
      items: [
        { name: 'Ниацинамид 2–5%',     reason: 'Снижает покраснения, укрепляет барьер' },
        { name: 'Церамиды + холестерол', reason: 'Восстанавливают защитный слой кожи' },
        { name: 'Пантенол (B5)',        reason: 'Снимает раздражение, возвращает комфорт' },
        { name: 'Гиалуроновая кислота', reason: 'Удерживает влагу — против стянутости' },
      ],
      caption: 'Концентрации и сочетания подобраны под чувствительную кожу с покраснениями.',
    },

    routine: {
      title: 'План ухода',
      tabs:  { morning: 'Утро', evening: 'Вечер' },
      steps: {
        morning: ['Очищение', 'Ниацинамид', 'Увлажнение', 'SPF'],
        evening: ['Очищение', 'Пантенол', 'Крем', 'Восстан-е'],
      },
    },

    timeline: {
      title: 'Когда вы увидите результат',
      steps: [
        { period: '1–2 нед.', text: 'Меньше стянутости, кожа выглядит спокойнее' },
        { period: '4 нед.',   text: 'Покраснения менее выраженные, кожа ровнее' },
        { period: '6–8 нед.', text: 'Барьер укреплён, стабильное состояние' },
      ],
    },
  },

  status: {
    ok:      'Подходит',
    replace: 'Заменить',
    missing: 'Нет',
  },

  howItWorks: {
    titleA: 'Как из хаоса получается',
    titleB: 'понятный план',
    flow:   ['Ваши средства', 'Анализ состава', 'План ухода'],
    steps: [
      { n: '01', title: 'Опишите кожу и покажите баночки',     text: 'Тип кожи, проблемы, цели, что уже стоит на полке. Можно текстом или фото.' },
      { n: '02', title: 'Разбираем состав каждой баночки',      text: 'Смотрим, что подходит вашей коже, что дублируется, что раздражает и чего не хватает.' },
      { n: '03', title: 'Получаете план — пошагово',            text: 'Что оставить, что убрать, что докупить и как использовать утром и вечером.' },
    ],
  },

  whyBetter: {
    titleA: 'Не ещё один совет из интернета.',
    titleB: 'А план под вашу кожу.',
    cards: [
      { title: 'Не по трендам',                    text: 'Мы смотрим на вашу кожу и состав, а не на популярность продукта.' },
      { title: 'Не нужно покупать всё заново',     text: 'Сначала проверяем, что из вашего ухода уже можно оставить.' },
      { title: 'Без лишних активов',               text: 'Показываем, что действительно нужно, а что может раздражать.' },
      { title: 'Понятная инструкция',              text: 'Утро, вечер, частота использования и конкретные рекомендации.' },
    ],
    tagline: 'SkinBloom не уговаривает купить всё заново. Помогаем понять, что из вашего ухода уже работает — и чего действительно не хватает.',
  },

  trust: {
    titleA: 'Честно, понятно',
    titleB: 'и без лишних обещаний',
    cards: [
      { title: 'Не заменяет дерматолога',              text: 'Если есть заболевание кожи, лучше обратиться к врачу.' },
      { title: 'Не заставляет покупать всё заново',    text: 'Мы сначала анализируем средства, которые у вас уже есть.' },
      { title: 'Фокус на составе',                     text: 'Смотрим активы, концентрации, совместимость и возможные раздражители.' },
      { title: 'Данные конфиденциальны',               text: 'Информация используется только для создания вашего отчёта.' },
    ],
  },

  planSection: {
    titleA:   'Начнём с вашей кожи',
    subtitle: 'Несколько вопросов — и через пару минут пришлём готовый план на e-mail.',
  },

  faq: {
    title: 'Вопросы и ответы',
    items: [
      { q: 'Это заменяет дерматолога?',
        a: 'Нет. SkinBloom — это инструмент для разбора состава и подбора персонального ухода. Если у вас есть заболевание кожи (акне, розацеа, экзема), лучше обратиться к дерматологу.' },
      { q: 'Нужно ли покупать новые средства?',
        a: 'Не обязательно. Сначала мы анализируем то, что у вас уже есть, и показываем, что можно оставить. Замены рекомендуются только там, где средство действительно не подходит.' },
      { q: 'Можно ли добавить косметику, которая уже есть дома?',
        a: 'Да, именно так и работает анализ. Вы указываете средства, которыми уже пользуетесь, — и мы разбираем, что из них подходит вашей коже, что стоит заменить и чего не хватает.' },
      { q: 'Что будет в отчёте?',
        a: 'Персональный профиль кожи, план ухода на утро и вечер, анализ совместимости активов, список ингредиентов — что использовать и чего избегать, конкретные рекомендации по продуктам.' },
      { q: 'Когда я получу план?',
        a: 'Отчёт готовится на основе ваших ответов и обычно доступен сразу после заполнения анкеты. Готовый отчёт отправляется на email.' },
      { q: 'Что если я не знаю свой тип кожи?',
        a: 'Не страшно. В анкете есть подсказки и уточняющие вопросы, которые помогут определить тип кожи по симптомам. Выберите «Не знаю» — и мы поможем разобраться.' },
      { q: 'Подойдёт ли это для чувствительной кожи?',
        a: 'Да, особенно. Для чувствительной кожи важно понимать, какие активы подходят, а какие могут раздражать. Анализ как раз помогает избежать лишних раздражителей и подобрать мягкий, но эффективный уход.' },
    ],
  },

  finalCta: {
    eyebrow: '5 минут — и план у вас',
    titleA:  'Пора разобраться',
    titleB:  'в своей косметике',
    body:    '5 минут — и в почте лежит план под вашу кожу.\nНе советы из интернета, а конкретные шаги под ваш состав.',
    cta:     'Получить мой план',
    trust:   '12 000+ планов создано',
  },

  form: {
    pageH1A:    'Создадим ваш',
    pageH1B:    'персональный уход',
    pageSub:    'Расскажите немного о себе, и мы начнём подготовку.',
    progress:   'Прогресс',
    stepLabel:  'Шаг {n} из {total}',
    back:       'Назад',
    next:       'Далее',
    submit:     'Составить мой план — {price}',
    fineprint:  'Конфиденциально · Готовый план — на e-mail · 100 % возврат, если не подойдёт',

    skinTypes: {
      dry: 'Сухая', oily: 'Жирная', combo: 'Комбинированная',
      sensitive: 'Чувствительная', unknown: 'Не знаю',
    },

    skin: {
      eyebrowSkinType: 'Тип кожи: {type}',
      title:           'Расскажите немного о вашей коже',
      subtitle:        'Тип, состояние, что нравится, а что нет — чем подробнее, тем точнее план.',
      placeholder:     'Например: кожа сухая, утром есть стянутость, иногда появляются покраснения на щеках.',
      hint:            'Минимум пара слов. Чем больше деталей, тем лучше.',
    },

    allergies: {
      title:        'Есть аллергии или непереносимость?',
      subtitle:     'Чтобы мы точно их исключили из вашего плана.',
      yes:          'Да, есть',
      no:           'Нет, всё ок',
      labelDetails: 'На что у вас аллергия?',
      placeholder:  'Например: витамин C, эфирные масла, орехи...',
      okMessage:    'Отлично — пропускаем этот шаг.',
    },

    products: {
      title:           'Расскажете о текущих средствах?',
      subtitle:        'Можно перечислить текстом, добавить фото — или оставить пустым.',
      labelText:       'Перечислите средства',
      placeholderText: 'Например: умывалка CeraVe, крем La Roche-Posay, сыворотка с витамином C...',
      orDivider:       'и / или',
      labelPhoto:      'Загрузите фото',
      dropzonePrompt:  'Перетащите фото или выберите файл',
      removeFile:      'Убрать файл',
      hint:            'Можно сфотографировать баночки одним кадром — главное, чтобы названия читались.',
    },

    contact: {
      title:       'Куда отправить готовый план?',
      subtitle:    'Email — мы пришлём отчёт через несколько минут.',
      placeholder: 'example@gmail.com',
      hint:        'Только для отправки отчёта. Никакого спама.',
    },

    loading: {
      title:    'Анализируем ваш профиль кожи…',
      subtitle: 'Это займёт совсем чуть-чуть.',
    },

    limit: {
      titleA:   'Мы достигли лимита',
      titleB:   'новых заявок',
      body:     'Алгоритм временно не принимает новые запросы из-за высокой нагрузки. Скоро вернёмся — заглядывайте позже 🧡',
      cta:      'Вернуться на главную',
      footer:   'Мы сообщим на сайте, когда появится окно для новых планов ухода.',
    },
  },

  // ── /example page ────────────────────────────────────────────────────────
  example: {
    backHome: 'Вернуться на главную',
    eyebrow:  'Персональный отчёт',
    title:    'Пример отчёта SkinBloom',
    subtitle: 'Создан на основе анализа вашей кожи и ответов на вопросы анкеты.',
    meta: {
      date:   'Дата создания',
      dateValue: '24 мая 2024',
      id:     'ID отчёта',
      idValue: 'SB-240524-001',
    },
    score: {
      label:    'Общий индекс кожи',
      good:     'Отлично',
      heading:  'Ваша кожа в хорошем состоянии',
      body:     'Продолжайте текущий уход и обратите внимание на зоны для улучшения.',
      scale:    ['Низкий', 'Средний', 'Отличный'],
    },
    sections: {
      analysis:    'Анализ вашей кожи',
      recommendations: 'Рекомендации по составу и продуктам',
      detailedPlan:    'Детальный план ухода',
      stages:          'Подбор средств по этапам',
      forecast:        'Ожидаемые изменения',
    },
    profile: {
      title: 'Профиль кожи',
      rows: [
        { label: 'Тип кожи',         value: 'Сухая' },
        { label: 'Чувствительность', value: 'Высокая' },
        { label: 'Покраснения',      value: 'На щеках' },
        { label: 'Стянутость',       value: 'После умывания' },
        { label: 'Реактивность',     value: 'На активы' },
      ],
    },
    zones: {
      title: 'Зоны для улучшения',
      sub:   'На что направлен план',
      items: ['Покраснения', 'Стянутость', 'Барьер кожи', 'Чувствительность'],
      tipLabel: 'Совет:',
      tipBody:  'мягкое очищение и восстанавливающий крем помогают со всеми зонами сразу.',
    },
    carePlan: {
      title:   'План ухода',
      sub:     'Утро · Вечер',
      steps:   ['Очищение', 'Ниацинамид', 'Увлажнение', 'SPF'],
      cta:     'Смотреть полный план',
    },
    ingredients: {
      title: 'Ключевые ингредиенты',
      items: [
        { name: 'Ниацинамид (2–5%)',   note: 'Снижает покраснения, укрепляет барьер' },
        { name: 'Церамиды',             note: 'Восстанавливают защитный слой' },
        { name: 'Гиалуроновая кислота', note: 'Увлажняет, снижает стянутость' },
        { name: 'Пантенол (B5)',        note: 'Снимает раздражение' },
      ],
      extra: '+ Глюконат цинка — при редких воспалениях',
    },
    productRecs: {
      title: 'Нужна замена',
      swaps: [
        { from: 'TO Niacinamide 10% + Zinc',   to: 'Geek & Gorgeous Stress Less' },
        { from: 'La Roche-Posay Effaclar H',   to: 'LRP Cicaplast B5 Light' },
        { from: null,                           to: 'Balea Panthenol Serum' },
        { from: null,                           to: 'TO Ascorbyl Glucoside' },
      ],
    },
    tips: {
      title: 'Советы и рекомендации',
      items: [
        'Используйте SPF каждый день, даже зимой',
        'Не забывайте про увлажнение — барьер требует внимания',
        'Избегайте ниацинамида 10%+ при чувствительной коже',
        'Вводите новые средства по одному раз в 2 недели',
        'Мягкий витамин C — утром, 3 раза в неделю',
      ],
    },
    detailed: {
      eyebrow: 'Шаг за шагом',
      heading: 'Ваш итоговый план ухода',
      tabs: { morning: 'Утро', evening: 'Вечер', weekly: 'По неделям' },
      stepTitles: {
        cleanse:     'Очищение',
        niacin:      'Ниацинамид 2–5%',
        moisturise:  'Увлажнение',
        spf:         'SPF',
        panthenol:   'Пантенол (2–5%)',
        creamRepair: 'Восстанавливающий крем',
        vitaminC:    'Пн/Ср/Пт — Витамин C',
      },
      productNotes: {
        niacin10Strong:  'TO Niacinamide 10% — слишком сильный',
        effaclarMorning: 'Effaclar H — не подходит',
        effaclarEvening: 'Effaclar H — недостаточный',
      },
    },
    stage: {
      shouldHave: 'Должно быть',
      avoid:      'Избегать',
      yourProducts: 'Ваши средства',
      examples:     'Примеры средств',
      noProduct:    'Нет подходящего средства',
      stages: [
        {
          title: 'Очищение (утро и вечер)',
          shouldHave: ['Мягкие ПАВ', 'Нет спиртов и отдушек', 'Церамиды / глицерин / аминокислоты'],
          avoid: ['Кислотные тоники', 'Жёсткие гели для проблемной кожи', 'Сильно пенящие формулы'],
          yourProducts: [{ name: 'CeraVe Hydrating Cleanser', ok: true }, { name: 'Pixi Glow Tonic', ok: false }],
          examples: [
            { tier: 'Бюджет', items: ['CeraVe Hydrating Cleanser', 'Simple Refreshing Facial Wash'] },
            { tier: 'Средний', items: ['LRP Toleriane Dermo Cleanser', 'Bioderma Sensibio Foaming Gel'] },
          ],
        },
        {
          title: 'Ниацинамид (утро)',
          shouldHave: ['Концентрация 2–5%', 'Без цинка или минимум', 'Успокаивающие добавки'],
          avoid: ['Концентрации 10%+', 'Комбо с кислотами', 'Формулы с пощипыванием'],
          yourProducts: [{ name: 'TO Niacinamide 10% + Zinc', ok: false }],
          examples: [
            { tier: 'Бюджет', items: ['TO Niacinamide 5%', 'Revolution 2% Niacinamide'] },
            { tier: 'Средний', items: ['G&G Stress Less', 'LRP Mela B3'] },
          ],
        },
        {
          title: 'Увлажнение (утро и вечер)',
          shouldHave: ['Церамиды', 'Холестерол', 'Жирные кислоты', 'Лёгкая текстура'],
          avoid: ['Формулы для жирной кожи', 'Спирты', 'Кислые ингредиенты'],
          yourProducts: [{ name: 'La Roche-Posay Effaclar H', ok: false }],
          examples: [
            { tier: 'Бюджет', items: ['CeraVe Moisturising Cream', 'Balea Cica Cream'] },
            { tier: 'Средний', items: ['LRP Cicaplast B5 Light', 'Bioderma Atoderm Gel-Crème'] },
          ],
        },
        {
          title: 'SPF (утро)',
          shouldHave: ['SPF 50', 'Лёгкая текстура', 'Без отдушек', 'Подходит чувствительной коже'],
          avoid: [],
          yourProducts: [{ name: 'Garnier Ambre Solaire Fluid SPF50', ok: true }],
          examples: [
            { tier: 'Средний', items: ['LRP UVMune 400'] },
            { tier: 'Премиум', items: ['SkinCeuticals Ultra Facial Defense'] },
          ],
        },
        {
          title: 'Пантенол (вечер)',
          shouldHave: ['2–5% пантенола', 'Без спиртов', 'Без кислот'],
          avoid: [],
          yourProducts: [],
          examples: [
            { tier: 'Бюджет', items: ['Balea Panthenol Serum'] },
            { tier: 'Средний', items: ['LRP Cicaplast B5 Serum'] },
          ],
        },
        {
          title: 'Витамин C (по дням, утром)',
          shouldHave: ['Стабильные формы (SAP/MAP/AG)', 'Концентрация 5–10%', 'Без раздражающих компонентов'],
          avoid: [],
          yourProducts: [],
          examples: [
            { tier: 'Бюджет', items: ['TO Ascorbyl Glucoside 12%'] },
            { tier: 'Средний', items: ['G&G C-Glow'] },
          ],
        },
      ],
    },
    timeline: {
      eyebrow: 'При соблюдении плана',
      heading: 'Ожидаемые изменения',
      steps: [
        { period: '1–2 недели', num: '01', items: ['Меньше стянутости', 'Кожа выглядит спокойнее'] },
        { period: '4 недели',   num: '02', items: ['Покраснения менее выраженные', 'Кожа мягче и ровнее'] },
        { period: '6–8 недель', num: '03', items: ['Укреплённый барьер', 'Снижение чувствительности', 'Стабильное состояние кожи'] },
      ],
    },
    finalCta: {
      eyebrow: 'Персональный план',
      heading: 'Хотите получить персональный план?',
      body:    'Выше — пример отчёта. Ваш план будет составлен под вашу кожу и средства.',
      cta:     'Получить план ухода',
    },
    confidential: 'Отчёт конфиденциален и доступен только вам',
  },
};

export type Translations = typeof ru;
